import React from "react";
import {makeStyles} from "@material-ui/core";
import {palette} from "./_constants";
import {useTranslation} from "react-i18next";
import i18n from "i18next";
import config from "../config";

const useStyles = makeStyles(theme => ({
    footer: {
        textAlign: 'center',
        fontSize: 'small',
        zIndex: theme.zIndex.drawer + 1,
        bottom: 0,
        width: '100%',
        backgroundColor: palette.primary.main,
        color: 'white',
    },
    links: {
        lineHeight: '40px',
    },
    link: {
        margin: '10px 20px',
    },
    copyrights: {
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));

export const Footer = () => {
    const {t} = useTranslation();
    const classes = useStyles();

    const date = new Date()
    const copyrights = `${t('_Common.Footer.Copyrights')}, 2012 - ${date.getFullYear()}. ${t('_Common.Footer.AllRights')}`;

    const websiteLink = `${config.websiteUrl}/${i18n.language}/legal/`;

    const termsLink = websiteLink + 'terms';
    const privacyLink = websiteLink + 'privacy';

    return (
        <footer className={classes.footer}>
            <div className={classes.links}>
                <a className={classes.link} href={privacyLink} target={'_blank'}>{t('_Common.Footer.PrivacyNotice')}</a>
                <a className={classes.link} href={termsLink} target={'_blank'}>{t('_Common.Footer.TermsOfUse')}</a>
            </div>
            <div className={classes.copyrights}>{ copyrights }</div>
        </footer>
    );
};
